import { supabase } from '@/integrations/supabase/client';
import { UpdateData } from '@/types/reprocessamento';

const RPC_CHUNK = 3000;
const HTTP_PARALLEL = 64;

function isRpcMissingFunction(error: { message?: string } | null): boolean {
  if (!error?.message) return false;
  const m = error.message.toLowerCase();
  return (
    (m.includes('function') || m.includes('função')) &&
    (m.includes('does not exist') || m.includes('not found') || m.includes('não existe'))
  );
}

async function updateOSViaHttp(
  updates: UpdateData[]
): Promise<{ updated: number; errors: number }> {
  let updated = 0;
  let errors = 0;
  for (let i = 0; i < updates.length; i += HTTP_PARALLEL) {
    const slice = updates.slice(i, i + HTTP_PARALLEL);
    const outcomes = await Promise.all(
      slice.map(async (u) => {
        const { error } = await supabase
          .from('ordens_servico')
          .update({
            valor_faturamento: u.valor_faturamento,
            imposto: u.imposto,
            valor_a_pagar: u.valor_a_pagar,
          })
          .eq('numero', u.numero);
        return !!error;
      })
    );
    for (const hadError of outcomes) {
      if (hadError) errors++;
      else updated++;
    }
  }
  return { updated, errors };
}

export const updateOSInDatabase = async (
  updates: UpdateData[]
): Promise<{ updated: number; errors: number }> => {
  if (updates.length === 0) return { updated: 0, errors: 0 };

  let totalUpdated = 0;
  let totalErrors = 0;
  let usedRpc = false;

  for (let i = 0; i < updates.length; i += RPC_CHUNK) {
    const chunk = updates.slice(i, i + RPC_CHUNK);
    const { data, error } = await supabase.rpc(
      'bulk_update_ordens_servico_reprocessamento',
      { p_updates: chunk }
    );

    if (!error) {
      usedRpc = true;
      totalUpdated += typeof data === 'number' ? data : chunk.length;
      continue;
    }

    if (!isRpcMissingFunction(error)) {
      totalErrors++;
    }

    const fb = await updateOSViaHttp(chunk);
    totalUpdated += fb.updated;
    totalErrors += fb.errors;
  }

  if (updates.length > 0 && !usedRpc && totalErrors === 0) {
    console.warn(
      '[reprocessamento] RPC bulk_update_ordens_servico_reprocessamento ausente; usando HTTP. Aplique a migration 20260402100000.'
    );
  }

  return { updated: totalUpdated, errors: totalErrors };
};
